import { render, staticRenderFns } from "./offcanvas.vue?vue&type=template&id=9ae0afbc"
import script from "./offcanvas.vue?vue&type=script&lang=ts"
export * from "./offcanvas.vue?vue&type=script&lang=ts"
import style0 from "./offcanvas.vue?vue&type=style&index=0&id=9ae0afbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports